// @flow
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Slide,
} from '@mui/material';
import { forwardRef } from 'react';
import Button from '@shared/components/button';
import { useI18n } from '@shared/helper/hooks';
import type { confirmDialogType } from '@shared/model/components/confirmDialogType';

const Transition = forwardRef((props, ref) => (
	<Slide direction={'up'} ref={ref} {...props} />
));

function ConfirmDialog({
	title,
	contentText,
	openDialog,
	handleClose,
	handleConfirm,
	loading = false,
}: confirmDialogType): React$Node {
	const { translate } = useI18n('finoShared');

	return (
		<Dialog
			open={openDialog}
			TransitionComponent={Transition}
			keepMounted
			onClose={() => handleClose(false)}
			maxWidth={'sm'}
			fullWidth
		>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>
				<DialogContentText>{contentText}</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button
					id={'confirm'}
					color={'success'}
					onClick={handleConfirm}
					loading={loading}
					variant={'contained'}
				>
					{translate('ok')}
				</Button>
				<Button
					id={'cancel'}
					color={'error'}
					onClick={() => handleClose(false)}
					variant={'contained'}
				>
					{translate('cancel')}
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default ConfirmDialog;
